<template>
    <div class="close_ticket_popup">
        <div class="close_ticket_popup_body">
            <div class="close_ticket_popup_content">
                <h2>Are you sure you want to close?</h2>
            </div>
            <div class="text-center">
                <button class="btn remove_yes_btn" @click="closeTicketPopupMethod">Decline</button>
                <button class="btn remove_yes_no" @click="closeTicketMethod">Yes, I want</button>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import toast from '@/services/toast';
const $ = window.jQuery = require('jquery');
import {
    bus
} from '@/main';
export default {
    name: 'closeTicketPopup',
    components: {},
    props: ['deleteTicketId'],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {
      document.body.classList.add('body_right_scroll_remove');
    },
    methods: {
        closeTicketPopupMethod() {
          bus.$emit('botTicketsPopupBus', false);
          document.body.classList.remove('body_right_scroll_remove');
        },
        closeTicketMethod() {
            this.$store.dispatch('botTicketCloseAction', { ticketId: this.deleteTicketId }).then
                ((res) => {
                    this.$store.dispatch('botTicketListAction', {filter : ''});
                    toast.success(res.data.msg);
                    this.closeTicketPopupMethod();
                }).catch((err) => {
                    toast.error(err.data.user_msg || err.data.msg);
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.close_ticket_popup {
    position: fixed;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    align-items: center;

    .close_ticket_popup_body {
        background: #000;
        width: 480px;
        margin: 0px auto;
        border-radius: 5px;
        padding: 20px 25px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }

    .close_ticket_popup_content h2 {
        font-size: 18px;
        color: #ffffff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-align: center;
        margin: 0 0 30px;
    }

    .remove_yes_btn {
        font-size: 16px;
        background: rgba(255, 18, 18, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_yes_no {
        font-size: 16px;
        background: rgba(33, 228, 0, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        margin-left: 15px;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }
}
</style>